export default __webpack_public_path__ + "static/media/other design2-01.9dc2ffb3.jpg";